import { refreshIconAnimated } from '@cas/components/icons/icons';
import styles from './LocationFilterHeader.module.scss';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';

interface LocationFilterHeaderProps {
  onSearch: () => void;
  onClearSearch: () => void;
  showClear: boolean;
  disableSearch: boolean;
}

export const LocationFilterHeader = ({
  onSearch,
  onClearSearch,
  showClear,
  disableSearch,
}: LocationFilterHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>
      <div className={styles.header__title}>{t('ByLocation')}</div>
      <div className={styles.header__actions}>
        {showClear && (
          <VdsButton variant="ghost" size="medium" onClick={onClearSearch}>
            {t('ClearLocationSearch')}
            <VdsIcon slot="icon-left" svgIcon="close" />
          </VdsButton>
        )}

        <VdsButton variant="secondary" size="medium" onClick={onSearch} disabled={disableSearch}>
          {t('SearchThisArea')}
          <VdsIcon
            slot="icon-left"
            svgIcon={disableSearch ? refreshIconAnimated : 'zoom-generic'}
          />
        </VdsButton>
      </div>
    </header>
  );
};

export default LocationFilterHeader;
